// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_3FG","cls2":"UserCard-cls2_W7U UserCard-cls1_3FG"};